module.exports = __webpack_public_path__ + "static/img/img_04.34997a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/img_04.jpg
// module id = omiV
// module chunks = 99